'use client';

import { useUserContext } from '@/context/user';
import { GET_ACCOUNT_CHIP } from '@/typed-graphql/query';
import { useQuery } from '@apollo/client';

const AccountChip = () => {
  const [{ isSignedIn }] = useUserContext();
  const { data } = useQuery(GET_ACCOUNT_CHIP, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: !isSignedIn,
  });
  const currentUser = data?.customer;

  const chipText =
    !isSignedIn || !currentUser
      ? ''
      : `Hi, ${(currentUser.firstname ? currentUser.firstname : currentUser.email?.split('@')[0]) || ''}`;

  return (
    <span className='group flex items-center gap-x-2'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='24'
        fill='none'
        viewBox='0 0 25 24'
        className='h-auto lg_w-5'
      >
        <path
          className='fill-#403732 lg_group-hover_fill-80583F'
          d='M16.068 13.72c2.14-1.24 3.59-3.55 3.59-6.2 0-3.95-3.2-7.16-7.16-7.16a7.166 7.166 0 00-7.15 7.17c0 2.65 1.45 4.96 3.59 6.2a11.679 11.679 0 00-7.97 9.08c-.07.41.2.81.61.88.41.07.81-.2.88-.61a10.2 10.2 0 019.99-8.4h.12c4.92.03 9.11 3.55 9.99 8.4.07.37.39.62.75.62.04 0 .09 0 .14-.01.41-.08.69-.47.61-.88-.8-4.37-3.94-7.8-7.99-9.09zm-9.2-6.19c0-3.11 2.53-5.64 5.64-5.64s5.64 2.53 5.64 5.64c0 3.09-2.49 5.6-5.57 5.63h-.14c-3.08-.04-5.57-2.55-5.57-5.63z'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M16.068 13.72c2.14-1.24 3.59-3.55 3.59-6.2 0-3.95-3.2-7.16-7.16-7.16a7.166 7.166 0 00-7.15 7.17c0 2.65 1.45 4.96 3.59 6.2a11.679 11.679 0 00-7.97 9.08c-.07.41.2.81.61.88.41.07.81-.2.88-.61a10.2 10.2 0 019.99-8.4h.12c4.92.03 9.11 3.55 9.99 8.4.07.37.39.62.75.62.04 0 .09 0 .14-.01.41-.08.69-.47.61-.88-.8-4.37-3.94-7.8-7.99-9.09zm-9.2-6.19c0-3.11 2.53-5.64 5.64-5.64s5.64 2.53 5.64 5.64c0 3.09-2.49 5.6-5.57 5.63h-.14c-3.08-.04-5.57-2.55-5.57-5.63z'
        />
      </svg>
      {chipText ? (
        <span
          data-cy='AccountChip-text'
          className='lg_group-hover_text-80583F'
        >
          {chipText}
        </span>
      ) : null}
    </span>
  );
};

export default AccountChip;
